import React from "react";
import { useTranslation } from "react-i18next";
import { ProfileFullNames, videoModelHrefs } from "../Layout";
import Messenger from "./Messenger";
import { Interaction } from "./LiveCam";
import { scrollIntoView } from "../Helpers/scrollTo";

interface ChattingProps {
    shortName?: string;
}
export const Chatting = (props: ChattingProps) => {
    const { shortName } = props;
    const { t } = useTranslation();
    const videoRef = React.useRef<HTMLVideoElement>(null);
    const [endedVideo, setEndedVideo] = React.useState<boolean>(false);
    const name = videoModelHrefs.includes(shortName || '') ? ProfileFullNames[shortName as keyof typeof ProfileFullNames] : ProfileFullNames['Lia'];

    const conversation: Interaction['conversation'] = [
         {sender: 'recipient', text:t("Hey Lia, ich bin ein großer Fan von dir 😳  Wie gehts dir?")},
         {sender: 'sender', text:t("Hey Alex, schön zu hören 😊  Mir gehts gut und selbst? ❤️")},
         {sender: 'recipient', text:t("Kannst du dich mal mir vielleicht mal ein Video von dir schicken in deinem Leder-Outfit?")},
         {sender: 'sender', text: t("Klar, mach ich doch gerne für dich. Warte kurz…"),},
     ];

    const handleVolumeChange = (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
        if (!videoRef.current) return;
        if (e.currentTarget.dataset.name === 'unmute') {
            e.currentTarget.hidden = true;
            const nextElement = e.currentTarget.nextElementSibling as HTMLElement;
            nextElement.hidden = false;
            videoRef.current.muted = false;
        } else {
            e.currentTarget.hidden = true;
            const previousElement = e.currentTarget.previousElementSibling as HTMLElement;
            previousElement.hidden = false;
            videoRef.current.muted = true;
        }
    }

    React.useEffect(() => {
        let interval: NodeJS.Timeout;
        if (videoRef.current) {
            interval = setInterval(() => {
                if (!videoRef.current) return;
                if (Math.floor(videoRef.current!.currentTime)) dispatchEvent(new CustomEvent('videoProgress'));
                if(Math.floor(videoRef.current!.currentTime) >= Math.floor(videoRef.current!.duration)) {
                    videoRef.current!.volume = 0;
                    setEndedVideo(true);
                    clearInterval(interval);
                }
            }, 1000);
        }
        return () => interval && clearInterval(interval);
    }, []);

    return (
        <>
            <div className="box margin-bottom-2">
                <div>
                    <h2 className="text-align-center">{t('Chatte direkt mit')} {name}</h2>
                    <p className="text-align-center">{t('Führe echte 1:1 Unterhaltungen wie hier im Beispiel')}</p>
                </div>
                <Messenger conversation={conversation} timing={{recipient: [1,18,52], sender: [10,21,46,64]}} />
                <button className="btn std-height flex-align-center gap-1-half" onClick={() => scrollIntoView('form_container')}>
                    {t('Jetzt selbst Chatten')} <span className="icon--ri send-plane-fill font-size-1"></span>
                </button>
            </div>
            <div className="box">
                <div  className="video-preview-livecam">
                <video ref={videoRef} autoPlay playsInline muted>
                    <source src="video/liaengel.mp4" type="video/mp4" />
                </video>
                <div className="volume-control">
                    <span className="icon--ri volume-mute-line font-size-2" data-name='unmute' onClick={handleVolumeChange}></span>
                    <span hidden className="icon--ri volume-down-line font-size-2" data-name='mute' onClick={handleVolumeChange}></span>
                </div>
                <div className="eg-label">
                        {endedVideo ? (
                        <small>{t('Beispiel-Video vorbei')}</small>
                        ) : (
                        <small>{t('Beispiel-Video')}</small>
                    )}
                </div>
           </div>
                <h2 className="margin-top-1">{t('Frage persönliche Video-Botschaften an!')}</h2>
                <p>{t('Du kannst deinen Models auch Anfragen für Fotos oder Videos schicken.')}<br/>
                    {t('Diese Erstellen diese dann - nur für dich!')}</p>
                <div className="clickable flex-align-flex-start gap-1-half text-color chatting-color" onClick={() => scrollIntoView('form_container')}>
                    <span className="icon--ri message-3-line"></span>
                    <p className="reset-margin">{t('Im Chat anfragen')}</p>
                </div>
            </div>
        </>
    )
}
